import { Card, CardContent, CardHeader, Grid, Link } from "@mui/material"
import { BooleanInput, DateInput, DateTimeInput, email, NumberInput, ReferenceInput, required, SaveButton, SelectInput, TextInput, Toolbar, useRecordContext } from "react-admin"
import { UserDeleteWithControl } from "../UserDeleteWithControl"

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { AdminBlockedWithConfirmation } from "../AdminBlockedWithConfirmation";
import TagsField from "@/src/components/TagsField";

const userProfileURL = `${import.meta.env.VITE_FRONTEND_URL}/profile/`;
export const SectionUserEditAccountInfo = (props: any) => {
    const record = useRecordContext(props);
    return (

        <Card variant="outlined">
            <Grid container spacing={1}>
                <CardHeader title={"Account info"} />
                {/* {record && <Link href={userProfileURL + record!.id} target="_blank"
                    color="inherit"
                    variant="inherit">
                    <OpenInNewIcon style={{ marginTop: '6px' }} />
                </Link>} */}
            </Grid>
            <CardContent>
                <TextInput variant="outlined" type="email" source="email" label="Email"
                    fullWidth helperText={false}
                    validate={[email(), required()]} />
                
                <ReferenceInput source="tenant" reference="tenant" label="Tenant" allowEmpty>
                    <SelectInput                         
                        fullWidth
                        helperText={false}
                        optionText="name"
                    />
                </ReferenceInput>

                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, sm: 4, xl: 4 }}>
                        <BooleanInput source="profileValid" helperText={false} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4, xl: 4 }}>
                        <BooleanInput source="verified" helperText={false} />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 4, xl: 4 }}>
                        <BooleanInput source="fake" helperText={false} />
                    </Grid>
                </Grid>
                {record &&
                    <Grid container spacing={1}>
                        <UserDeleteWithControl
                            source="deleted"
                            helperText={false}

                        />
                        {record.deleted &&
                            <Grid container spacing={1}>
                                <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                                    <DateInput variant="outlined" source="deletedAt"
                                        label="Deleted at" fullWidth helperText={false}
                                        disabled />
                                </Grid>
                                <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                                    <TextInput variant="outlined" source="deletedBy"
                                        label="Deleted by" fullWidth helperText={false}
                                        disabled />
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                }
                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, sm: 12, xl: 12 }}>
                        <AdminBlockedWithConfirmation
                            source="adminBlocked"
                            label="Blocked" />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 12, xl: 12 }}>
                        <TextInput variant="outlined" source="adminData.notes"
                            label="AdminData Notes" fullWidth helperText={false}
                            multiline />
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, sm: 3, xl: 3 }}>
                        <TextInput variant="outlined" source="verification"
                            label='Verification' helperText={false} fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 9, xl: 9 }}>
                        {/* <ArrayField source="externalLogins"  fieldKey="provider" label={"Providers"}>
                                        <SingleFieldList>
                                            <ChipField source="provider" />
                                        </SingleFieldList>

                                    </ArrayField> */}
                        <TagsField source="externalLogins"
                            fieldKey="provider" />
                    </Grid>
                </Grid>

                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                        <NumberInput variant="outlined" source="loginAttempts"
                            label="Login Attempts" helperText={false}
                            fullWidth />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                        <DateTimeInput variant="outlined" source="blockExpires"
                            label="Block expires" helperText={false}
                            fullWidth />
                    </Grid>
                </Grid>

                <Grid container spacing={1}>
                    <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                        <BooleanInput source="isOnline"
                            label="Is online" helperText={false} fullWidth
                        />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                        <DateTimeInput variant="outlined" source="lastSeen"
                            label="Last Seen" helperText={false} fullWidth />
                        {/* <DateTimeInput variant="outlined" source="onlineTime"
                            label="Online Time" helperText={false} fullWidth /> */}
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                        <DateTimeInput variant="outlined" source="createdAt"
                            label="Created at" helperText={false} fullWidth
                            disabled />
                    </Grid>
                    <Grid size={{ xs: 12, sm: 6, xl: 6 }}>
                        <DateTimeInput variant="outlined" source="updatedAt"
                            label="Updated at" helperText={false} fullWidth
                            disabled />
                    </Grid>
                </Grid>


                <SelectInput variant="outlined" source='role' label="Role"
                    helperText={false} fullWidth
                    choices={[
                        { id: 'user', name: "User" },
                        { id: 'admin', name: "Admin" },
                    ]}
                />
                {/* <LocationField source="location" />  */}

            </CardContent>
            <Toolbar
            // {...sanitizeToolbarProps(formProps)}
            >
                <SaveButton label="Save" />
            </Toolbar>
        </Card>

    )
}
